import "../../style/mobile/dashboard/M_ExamStore.css";
import icon1 from "../../../assets/mobile/dashboard/vuesax-linear-bag-happy.svg";
import icon2 from "../../../assets/mobile/dashboard/vuesax-linear-stickynote.svg";
import icon3 from "../../../assets/mobile/dashboard/vuesax-linear-clock.svg";
import icon4 from "../../../assets/mobile/dashboard/vuesax-linear-profile-2user.svg";
import icon5 from "../../../assets/mobile/dashboard/vuesax-linear-profile.svg";
import img1 from "../../../assets/mobile/dashboard/morteza-f-shojaei-8K9UGVCZGpw-unsplash (1).png";
import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useState } from "react";
import { useSelector } from "react-redux";
import moment from "jalali-moment";

let tab_data = [
  {
    id: 1,
    tab_name: "همه",
    isActive: true,
  },
  {
    id: 2,
    tab_name: "آزمون‌های‌ جاری",
    isActive: false,
  },
  {
    id: 3,
    tab_name: "آزمون‌های‌آینده",
    isActive: false,
  },
  {
    id: 4,
    tab_name: "آزمون‌های در حال برگزاری",
    isActive: false,
  },
];

const M_ExamStore = () => {
  var settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    className: "m-ExamStore-tab-content-slider-item",
  };
  const state = useSelector((state) => state.default);
  const [data] = useState(state.ExamData);
  const [TabData, setTabData] = useState(tab_data);

  //create tab data---------------------------------------------
  let all_tab_data = data.filter((item, index) => {
    return index < 8;
  });
  let thisWeek_tab_data = data.filter((item, index) => {
    return index < 8 && item.time_type === "thisWeek";
  });
  let future_tab_data = data.filter((item, index) => {
    return index < 8 && item.time_type === "future";
  });
  let live_tab_data = data.filter((item, index) => {
    return index < 8 && item.time_type === "live";
  });
  const [processing_data, set_processing_data] = useState(all_tab_data);
  //change tab----------------------------------------------------
  const [old_tab_id, set_old_tab_id] = useState(1);
  // const [active_tab,set_active_tab] = useState('all');
  const change_tab = (id) => {
    // console.log("tab" + id);
    let new_TabData = TabData.map((item) => {
      if (item.id === old_tab_id) {
        item.isActive = false;
      }
      if (item.id === id) {
        item.isActive = true;
      }
      return item;
    });
    setTabData(new_TabData);
    set_old_tab_id(id);
    if (id === 1) {
      set_processing_data(all_tab_data);
    } else if (id === 2) {
      set_processing_data(thisWeek_tab_data);
    } else if (id === 3) {
      set_processing_data(future_tab_data);
    } else if (id === 4) {
      set_processing_data(live_tab_data);
    }
  };

  moment.locale("en");
  return (
    <div className="m-ExamStore">
      <div className="m-ExamStore-title-box">
        <img
          className="m-ExamStore-title-box-icon"
          src={icon1}
          alt="ExamStore-icon"
        />
        <div className="m-ExamStore-title-box-text">فروشگاه آزمون‌ها</div>
      </div>
      <div className="m-ExamStore-tab-btn-container">
        {TabData.map((item) => (
          <div
            key={item.id}
            style={
              item.isActive
                ? { backgroundColor: "#2E81E8", color: "white" }
                : null
            }
            className="m-ExamStore-tab-btn-item"
            onClick={() => change_tab(item.id)}
          >
            {item.tab_name}
          </div>
        ))}
      </div>
      <div className="m-ExamStore-tab-content">
        <Slider {...settings}>
          {processing_data.map((item, index) => (
            <React.Fragment key={index}>
              <div className="m-ExamStore-tab-content-item">
                <img
                  className="m-ExamStore-tab-content-item-img-bg"
                  src={img1}
                  alt="exam-bg"
                />
                <div className="m-ExamStore-tab-content-item-cover"></div>
                <div className="m-ExamStore-tab-content-item-info">
                  <div className="m-ExamStore-tab-content-item-info-row1">
                    <img
                      src={icon2}
                      alt="exam-name-icon"
                      className="m-ExamStore-tab-content-item-info-row1-icon"
                    />
                    <div className="m-ExamStore-tab-content-item-info-row1-text">
                      {item.name}
                    </div>
                  </div>
                  <div className="m-ExamStore-tab-content-item-info-row2">
                    <div className="m-ExamStore-tab-content-item-info-row2-date-box">
                      <img
                        src={icon3}
                        alt="clock-icon"
                        className="m-ExamStore-tab-content-item-info-row2-date-box-img"
                      />
                      <div className="m-ExamStore-tab-content-item-info-row2-date-box-text">
                        {moment(item.date, 'YYYY/MM/DD').format('jYYYY/jM/jD')}
                      </div>
                    </div>
                    <div className="m-ExamStore-tab-content-item-info-row2-time-box">
                      ساعت <span>
                        {moment(item.date, 'YYYY/MM/DD HH:mm').locale("fa").format('HH:mm')}
                      </span>
                    </div>
                  </div>
                  <div className="m-ExamStore-tab-content-item-info-row3">
                    <img
                      className="m-ExamStore-tab-content-item-info-row3-icon"
                      src={item.type === 2 ? icon4 : icon5}
                      alt="icon"
                    />
                    <div className="m-ExamStore-tab-content-item-info-row3-text">
                      {item.type===1 && "انفرادی"}
                      {item.type===2 && "گروهی"}
                    </div>
                  </div>
                </div>
              </div>
            </React.Fragment>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default M_ExamStore;
